import React from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TitleModal } from '../../molecules/modal/TitleModal';
import { appStyles } from '../../../styles';
import { CARTNER_CONVOS } from '../../../constants/define/translation';
import { SummaryQuestionRecord } from '../../../repository/mytm/home/cartnerConvosRepository';
import { FormSummaryConvos } from './forms/FormSummaryConvos';

interface FormCartnerConvosModalModalProps {
  isOpenModal: boolean;
  onClose: () => void;
  record?: SummaryQuestionRecord;
}

export const FormSummaryModal = (props: FormCartnerConvosModalModalProps) => {
  const { isOpenModal, onClose, record } = props;
  const { t } = useTranslation(CARTNER_CONVOS);
  return (
    <StyledModal
      title={<TitleModal title={t('form.SummaryTile')} />}
      centered
      visible={isOpenModal}
      width={1050}
      footer={null}
      onCancel={() => {
        onClose();
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
      forceRender
    >
      <FormSummaryConvos record={record} />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .site-card-wrapper {
    ${appStyles.background.modalBgGray}
    & .card-item {
      text-align: center;
      padding: 1rem;
    }
  }

  & h4.ant-typography {
    ${appStyles.color.black}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .card-item .ant-image {
    cursor: pointer;
  }

  & .card-up-to-date {
    & .ant-image {
      padding: 0px;
      margin-left: 12px;
      & img {
        width: 92%;
        padding: 5px 0 0px 0;
      }
    }
  }
`;
